import { render, staticRenderFns } from "./AllReparationsAmount.vue?vue&type=template&id=40bb7555&scoped=true"
import script from "./AllReparationsAmount.vue?vue&type=script&lang=js"
export * from "./AllReparationsAmount.vue?vue&type=script&lang=js"
import style0 from "./AllReparationsAmount.vue?vue&type=style&index=0&id=40bb7555&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bb7555",
  null
  
)

export default component.exports